import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import LinkComponent from '../../../components/common/Link';
import PillarAPI from '../../PillarContainer/pillar-api';
import workshopApi from '../workshop-api';
import WorkshopInfoForm from './WorkshopInfoForm';
import WorkshopSummary from './WorkshopSummary';
import WorkshopWizard from './WorkshopWizard';
import {
  createDefaultWorkshopData,
  mapWorkshopResponseToForm,
} from '../utils/workshopForm';

const WorkShopEdition = () => {
  const {
    state: { workshopId },
  } = useLocation();

  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(true);
  const [pillarsLoaded, setPillarsLoaded] = useState(false);

  const [pillarList, setPillarList] = useState([]);
  const [workShopData, setWorkShopData] = useState(createDefaultWorkshopData);

  useEffect(() => {
    PillarAPI.fetchActivePillars()
      .then((response) => {
        setPillarList(response.data || []);
      })
      .catch((error) => {
        console.error('Error al obtener los pilares:', error);
      })
      .finally(() => {
        setPillarsLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (!pillarsLoaded) {
      return;
    }

    (async () => {
      try {
        const { data } = await workshopApi.fetchWorkShop(workshopId);
        setWorkShopData(mapWorkshopResponseToForm(data, pillarList));
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [pillarsLoaded, pillarList, workshopId]);

  const onNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const onPrev = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const workShopSteps = [
    {
      title: 'Información del taller',
      render: () => (
        <WorkshopInfoForm
          mode="edit"
          pillars={pillarList}
          onNext={onNext}
          workShopData={workShopData}
          setWorkShopData={setWorkShopData}
        />
      ),
    },
    {
      title: 'Resumen',
      render: () => (
        <WorkshopSummary
          mode="edit"
          workshopData={workShopData}
          onPrev={onPrev}
          id={workshopId}
        />
      ),
    },
  ];

  return (
    <div className="client-container">
      <div className="client__back-container">
        <LinkComponent title="Volver" url="/talleres" icon="arrow_back" />
      </div>

      {loading ? null : (
        <WorkshopWizard
          title="Editar taller"
          steps={workShopSteps}
          activeStep={activeStep}
        />
      )}
    </div>
  );
};

export default WorkShopEdition;
